import type { StylesConfig } from "react-select";

/** Shared react-select styles aligned with the admin design tokens. */
export function createReactSelectStyles<
  Option = unknown,
  IsMulti extends boolean = false,
>(): StylesConfig<Option, IsMulti> {
  return {
    control: (base, state) => ({
      ...base,
      backgroundColor: "var(--background)",
      borderColor: state.isFocused ? "var(--primary)" : "var(--border)",
      boxShadow: state.isFocused ? "0 0 0 1px var(--primary)" : "none",
      "&:hover": {
        borderColor: "var(--primary)",
      },
      borderRadius: "0.5rem",
      minHeight: "2.5rem",
      transition: "all 0.2s",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "var(--popover)",
      border: "1px solid var(--border)",
      borderRadius: "0.5rem",
      boxShadow:
        "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      overflow: "hidden",
      zIndex: 50,
      marginTop: "4px",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "var(--primary)"
        : state.isFocused
          ? "var(--accent)"
          : "transparent",
      color: state.isSelected
        ? "var(--primary-foreground)"
        : state.isFocused
          ? "var(--accent-foreground)"
          : "var(--popover-foreground)",
      "&:active": {
        backgroundColor: "var(--primary)",
        color: "var(--primary-foreground)",
      },
      cursor: "pointer",
      padding: "8px 12px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "var(--placeholder)",
    }),
    input: (base) => ({
      ...base,
      color: "var(--foreground)",
    }),
    singleValue: (base) => ({
      ...base,
      color: "var(--foreground)",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused
        ? "var(--primary)"
        : "var(--muted-foreground)",
      "&:hover": {
        color: "var(--primary)",
      },
    }),
    clearIndicator: (base) => ({
      ...base,
      color: "var(--muted-foreground)",
      "&:hover": {
        color: "var(--destructive)",
      },
    }),
  };
}
